<div class="dashboard-filter-panel"
	 [class.dashboard-filter-panel--no-background]="noBackground"
	 *ngIf="filterDataSource">
	<cs-filter-and-compare-bar [mDataSource]="filterDataSource"
							   [useLocalOnPage]="true"
							   [invertStyling]="false"
							   [hasCompare]="false"
							   [renderStubs]="false"
							   (selectionChanged)="onFilterSelectionChanged($event)">
	</cs-filter-and-compare-bar>
</div>
